export default __webpack_public_path__ + "images/ceiling-fan-background.1704d678717fd5f885e73caa416bc5a3.png";